export default __webpack_public_path__ + "static/category-brochure-tablet-0a0a7769bfd730c7364c1d5aef4d9c06.png";